const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i

export function formatNotificationContent(content?: string): string {
  if (!content) return ''

  const text = content.trim()
  if (HTML_TAG_PATTERN.test(text)) {
    return text
  }

  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\n/g, '<br>')
}
